/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userProfileUpdate

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userProfileUpdate.UserProfileUpdateApi
import features.userProfileUpdate.models.UserProfileModel
import features.userProfileUpdate.serializeUserProfileUpdateState
import features.userProfileUpdate.models.UpdateUserProfileRequest

import kotlinx.serialization.decodeFromString

/**
 * Update a users' profile [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserProfileUpdateApi")
class UserProfileUpdateApiJs {

    /**
     * Update a users' profile
     */


    
    fun updateUserProfile(overrideHeaders: String?,
serializedUpdateUserProfileRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = UserProfileUpdateApi().updateUserProfile(
            overrideHeaders = decodedOverrideHeaders,
                updateUserProfileRequest = Json.decodeFromString(
                    serializedUpdateUserProfileRequest
                )
            ).toJsonResult<UserProfileModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeUserProfileUpdateState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserProfileUpdateApi().userProfileUpdateState.serializeUserProfileUpdateState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
